import { Col, Row } from 'antd';
import { RevxCoverCard } from 'components/RevxCoverCard';
import { PaperOrientation } from 'components/RevxCoverCard/PaperOrientation';
import { OrientationEnum } from 'domains/skuDomain';
import { upperFirst } from 'lodash-es';
import { useState } from 'react';

export interface OrientationInputProps {
  options?: OrientationEnum[];
  value?: OrientationEnum;
  onChange?: (value: OrientationEnum) => void;
}
export const RevxOrientationRadioGroup = ({
  options = [OrientationEnum.portrait, OrientationEnum.landscape],
  value,
  onChange,
}: OrientationInputProps) => {
  const [val, setVal] = useState<OrientationEnum | undefined>(value);

  return (
    <Row gutter={22}>
      {options.map((orientation) => {
        return (
          <Col key={orientation.toString()}>
            <RevxCoverCard
              title={upperFirst(orientation.toString())}
              checked={val === orientation}
              onChange={() => {
                if (val !== orientation) {
                  setVal(orientation);
                  if (onChange) {
                    onChange(orientation);
                  }
                }
              }}
            >
              <PaperOrientation type={orientation} />
            </RevxCoverCard>
          </Col>
        );
      })}
    </Row>
  );
};
